import { addPeopleToSharedFolderPeoplePickerText } from './SharedFolderPeoplePicker.locstring.json';
import { addShareableFolderToYourMailboxText } from 'owa-locstrings/lib/strings/addshareablefoldertoyourmailboxtext.locstring.json';
import loc from 'owa-localize';
import { LazyPeoplePickerDialog } from 'owa-people-picker-dialog';

import * as React from 'react';
import store from '../store/store';
import { addSharedFolderUser } from 'owa-folders';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { observer } from 'mobx-react';
import showSharedFolderPeoplePickerDialog from '../actions/showSharedFolderPeoplePickerDialog';

/**
 * Wrapper component for shared Folder for peoplepicker dialog
 */
@observer
export default class SharedFolderPeoplePicker extends React.Component<{}, {}> {
    render() {
        return (
            store.showPeoplePickerDialog && (
                <LazyPeoplePickerDialog
                    title={loc(addShareableFolderToYourMailboxText)}
                    subTitle={loc(addPeopleToSharedFolderPeoplePickerText)}
                    addCallback={this.addSharedFolderUserCallback}
                    cancelCallback={this.cancelSharedFolderCallback}
                />
            )
        );
    }

    /**
     * Add share folder callback that lazily calls AddSharedFolderUser action
     * @param emailAddressWrapper - User mailbox information who need to be added
     */
    private addSharedFolderUserCallback = async (emailAddressWrapper: EmailAddressWrapper) => {
        addSharedFolderUser(emailAddressWrapper.Name, emailAddressWrapper.EmailAddress);
    };

    /**
     * Cancel callback for shared folder PeoplePicker dialog, it reset the flag for sharedfolder wrapper component
     * so that next time when user clicks on addSharedFolder option, in context menu, wrapper component rerenders
     */
    private cancelSharedFolderCallback = () => {
        showSharedFolderPeoplePickerDialog(false);
    };
}
